// src/modules/socialhive/mobile/MobileEventsNotification.jsx
import React, { useEffect, useState } from "react";
import "./MobileEventsNotification.css";
import Services from "../../services/Services";
import { useLanguage } from "../../LanguageProvider";
import { useNavigate } from "react-router-dom";

export default function MobileEventsNotification({ token, setShowNotifications }) {
    const { getTranslation, language } = useLanguage();
    const [loading, setLoading] = useState(false);
    const [notifs, setNotifs] = useState([]);
    const navigate = useNavigate();

    const LOCALE_MAP = {
        tr: "tr-TR",
        en: "en-US",
        de: "de-DE",
        es: "es-ES",
        fr: "fr-FR",
        it: "it-IT",
    };

    const formatDate = (ts) => {
        if (!ts) return "";
        const d = new Date(Number(ts) * 1000);
        const day = d.getDate();
        const month = d.toLocaleString(LOCALE_MAP[language] || "en-US", {
            month: "long",
        });
        return `${day} ${month}`;
    };

    const parseNotificationTitle = (rawTitle) => {
        if (!rawTitle) return "";

        const marker = " has been created a new event";
        if (rawTitle.endsWith(marker)) {
            const creator = rawTitle.replace(marker, "").trim();
            return getTranslation("hasCreatedAnEvent", { creator });
        }

        return rawTitle;
    };

    const handleOpenNotification = (notif) => {
        const eventID = notif?.data?.eventID || notif?.data?.eventId;
        if (!eventID) return;

        navigate(`/event/${eventID}/details`);
        setShowNotifications(false)
    };

    useEffect(() => {
        if (!token) return;
        setLoading(true);

        Services.GetUserNotifications(token)
            .then((res) => {
                if (res?.data?.status && Array.isArray(res?.data?.result)) {
                    // sadece type: "event" olanlar
                    const onlyEvents = res.data.result.filter(
                        (n) => n.type === "event"
                    );
                    setNotifs(onlyEvents);
                } else {
                    setNotifs([]);
                }
            })
            .catch(() => setNotifs([]))
            .finally(() => setLoading(false));
    }, [token]);

    if (loading) {
        return (
            <div className="mnoti-page">
                <div className="mnoti-loading">{getTranslation("loading")}</div>
            </div>
        );
    }

    if (!notifs.length) {
        return (
            <div className="mnoti-page">
                <div className="mnoti-empty">{getTranslation("noNotifications")}</div>
            </div>
        );
    }

    return (
        <div className="mnoti-page">
            {notifs.map((n) => (
                <span
                    key={n.id}
                    type="button"
                    className="mnoti-card"
                    onClick={() => handleOpenNotification(n)}
                >
                    <div className="mnoti-img-wrap">
                        <img
                            src={n.image}
                            alt="notif"
                            className="mnoti-img"
                            onError={(e) => {
                                e.currentTarget.src =
                                    "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><rect width='100%' height='100%' fill='%23222'/></svg>";
                            }}
                        />
                    </div>

                    <div className="mnoti-body">
                        <div className="mnoti-title">{parseNotificationTitle(n.title)}</div>
                        <div className="mnoti-date">{formatDate(n.createdDateTime)}</div>
                    </div>
                </span>
            ))}
        </div>
    );
}